import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { useParams } from 'react-router-dom';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import createRemarkDocumentLinks from './plugins/remarkDocumentLinks';

export type MarkdownInlineRendererProps = {
  content?: string;
};

const MarkdownInlineRenderer: React.FC<MarkdownInlineRendererProps> = ({ content }) => {
  const { id: organizationIdFromRoute } = useParams();

  const documentLinksPlugin = React.useMemo(
    () => createRemarkDocumentLinks({ organizationId: organizationIdFromRoute }),
    [organizationIdFromRoute],
  );

  const normalizedContent = content?.trim();

  if (!normalizedContent) {
    return null;
  }

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, documentLinksPlugin]}
      rehypePlugins={[rehypeRaw]}
      components={{
        h1: ({ children }) => <strong>{children} </strong>,
        h2: ({ children }) => <strong>{children} </strong>,
        h3: ({ children }) => <strong>{children} </strong>,
        h4: ({ children }) => <strong>{children} </strong>,
        h5: ({ children }) => <strong>{children} </strong>,
        h6: ({ children }) => <strong>{children} </strong>,
        p: ({ children }) => <>{children} </>,
        br: () => <> </>,
        ul: ({ children }) => <>{children} </>,
        ol: ({ children }) => <>{children} </>,
        li: ({ children }) => <>{children} </>,
        a: ({ children }) => <>{children}</>,
        pre: ({ children }) => <>{children} </>,
        code: ({ children }) => <>{children}</>,
        blockquote: ({ children }) => <>{children} </>,
        hr: () => <> </>,
        table: ({ children }) => <>{children} </>,
        thead: ({ children }) => <>{children} </>,
        tbody: ({ children }) => <>{children} </>,
        tr: ({ children }) => <>{children} </>,
        th: ({ children }) => <>{children} </>,
        td: ({ children }) => <>{children} </>,
        input: () => null,
        img: () => null,
        div: ({ children }) => <>{children} </>,
      }}
    >
      {normalizedContent}
    </ReactMarkdown>
  );
};

export default React.memo(MarkdownInlineRenderer);
